import React from 'react'
import useTrans from '../../../hooks/useTrans'
import Alert from '../../atoms/Alert/Alert'
const CheckoutAlerts = ({ errori }) => {
  const t = useTrans()
  const getPlaceholder = (errore) => {
    switch (errore.tipo) {
      case 'no_multipli':
        return {
          placeholder: t(
            "L'articolo {0} contiene sfusi. Ordina per imballi e/o sotto imballi per ottenere uno sconto del 2%.",
            [errore.riga.articolo.codice]
          ),
          link: t('Modifica quantità'),
          alert: false,
        }

      case 'no_spedizione_gratis':
        return {
          placeholder: t(
            `Risparmia il costo della spedizione ordinando almeno {0} Euro di merce a imballi e sotto imballi originali!`,
            [errore?.importo_spedizione_gratuita]
          ),
          link: null,
          alert: false,
          noClick: true,
        }
    }
  }

  return (
    <div>
      {errori &&
        errori
          ?.filter(
            (errore) => errore?.tipo === 'no_spedizione_gratis' || errore?.tipo === 'no_multipli'
          )
          .map((errore) => (
            <div style={{ marginBottom: 15 }} key={errore.tipo}>
              <Alert
                full
                placeholder={getPlaceholder(errore)?.placeholder}
                variant={!getPlaceholder(errore)?.alert && 'info'}
              />
            </div>
          ))}
    </div>
  )
}

export default CheckoutAlerts
